import { inject, Injectable } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

const languages = {
  pt: 'pt-br',
  es: 'es-ar',
  en: 'en-us',
} as const;

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly translocoService = inject(TranslocoService);

  setLanguage(language: string) {
    if (language) {
      const [prefix] = language.split('-');
      this.translocoService.setActiveLang(prefix);
    }
  }

  getCurrentLanguage(): string {
    const activeLang = this.translocoService.getActiveLang();
    return languages[activeLang as keyof typeof languages] || 'en-us';
  }
}
